import {isFeatureEnabled} from '@github-ui/feature-flags'
import {AlphaLabel} from '@github-ui/lifecycle-labels/alpha'
import {ViewSwitch} from '@github-ui/markdown-editor-view-switch'
import {clsx} from 'clsx'

import type {MarkdownViewMode} from '../types'
import styles from './Header.module.css'

export interface HeaderProps {
  onChangeViewMode?: (view: MarkdownViewMode) => void
  selectedView?: MarkdownViewMode
  children?: React.ReactNode
  uploadInProgress?: boolean
}

/**
 * Header layout container.
 * Important: this is also rendered by error fallbacks so logic that might fail should be kept to an absolute minimum.
 */
export function Header({onChangeViewMode, selectedView = 'hybrid', children, uploadInProgress = false}: HeaderProps) {
  const toolbarRedesignEnabled = isFeatureEnabled('markdown_experience_toolbar_redesign')

  const viewSwitch = (
    <ViewSwitch
      selectedView={selectedView}
      onViewSelect={onChangeViewMode}
      disabled={!onChangeViewMode || uploadInProgress}
    />
  )

  return (
    <div className={clsx(styles.header, toolbarRedesignEnabled && styles.redesignEnabled)}>
      {!toolbarRedesignEnabled && viewSwitch}

      {children}

      {/* Shipping publicly? Make sure to update the `ErrorFallback` messaging as well. */}
      <AlphaLabel className={styles.previewLabel} />
      {toolbarRedesignEnabled && viewSwitch}
    </div>
  )
}

try{ Header.displayName ||= 'Header' } catch {}